module.exports = __webpack_public_path__ + "static/media/img_03.2247270b.png";